import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { GoogleAnalyticsEventType } from 'enums/GoogleAnalyticsEventType';
import { BorrowerStatus } from 'enums/curo/BorrowerStatus';
import { CuroApplicationVariables } from 'enums/curo/Variables';
import { getApplicationSelector } from 'handlers/curo-handlers/selectors';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import useGoogleAnalytics from 'hooks/useGoogleAnalytics';
import LoaderStep from 'pages/CuroPages/ApplicationProcess/steps/LoaderStep';
import { organicCreditAndAutoOriginationCheck, refiCreditCheck } from 'thunks';

const CreditAndAutoOriginationCheckStep = () => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const trackEvent = useGoogleAnalytics();

  const application = useSelector(getApplicationSelector);

  const runCreditAndAutoOriginationCheck = async () => {
    switch (application?.variables[CuroApplicationVariables.BorrowerStatus]) {
      case BorrowerStatus.Former:
      case BorrowerStatus.New:
        await dispatchWithUnwrap(organicCreditAndAutoOriginationCheck());
        break;
      case BorrowerStatus.Existing:
        await dispatchWithUnwrap(refiCreditCheck());
        break;
      default:
        break;
    }
    trackEvent(GoogleAnalyticsEventType.PrequalCompleted);
  };

  useEffect(() => {
    runCreditAndAutoOriginationCheck();
  }, []);

  return <LoaderStep />;
};

export default CreditAndAutoOriginationCheckStep;
